document.addEventListener("DOMContentLoaded", () => {
  const tabContainers = document.querySelectorAll(".service-tech");

  tabContainers.forEach(container => {
    const tabs = container.querySelectorAll(".service-tech__tab");

    tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => {
        activateTab(container, index);
      });
    });

    // Initialize first tab
    activateTab(container, 0);
  });
});

function activateTab(container, index) {
  const tabs = container.querySelectorAll(".service-tech__tab");
  const contents = container.querySelectorAll(".service-tech__content-panel");

  if (!tabs[index] || !contents[index]) return;

  // Remove active classes
  tabs.forEach(t => t.classList.remove("active"));
  contents.forEach(c => c.classList.remove("active"));

  // Add active classes
  tabs[index].classList.add("active");
  contents[index].classList.add("active");

  // Update background color class
  const tab = tabs[index];
  const bgClass = tab.getAttribute("data-bg-class");
  const serviceTech = container.closest(".service-tech");

  if (serviceTech) {
    serviceTech.classList.forEach(cls => {
      if (cls.startsWith("service-tech--")) {
        serviceTech.classList.remove(cls);
      }
    });
    if (bgClass) {
      serviceTech.classList.add(bgClass);
    }
  }

  // Update image src
  const imageLink = tab.getAttribute("data-image-link");
  const imageElement = container.querySelector(".service-tech__image");
  if (imageElement && imageLink) {
    imageElement.src = imageLink;
  }
}